<template>
  <div v-if="faqs">
    <v-layout class="pb-2">
      <span class="subheading"
        ><b>{{ $t("faqs.title") }}</b></span
      >
    </v-layout>
    <v-layout>
      <v-expansion-panel class="border-grey-all">
        <v-expansion-panel-content v-for="(faq, i) in faqs" :key="i">
          <template v-slot:header>
            <div>
              <b>{{ faq.text }}</b>
            </div>
          </template>
          <v-card class="px-2">
            <v-card-text class="pb-2 pt-0">
              {{ faq.value }}
              <div v-if="faq.image" class="py-1">
                <v-img
                  max-height="40%"
                  max-width="40%"
                  contain
                  :src="require('@/assets/'+faq.image )"
                /></div>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-layout>
  </div>
</template>

<script>
import i18n from "@/i18n";
export default {
  name: "FAQs",
  props: {
    faqs: {
      default: null,
    },
  },
};
</script>

<style>
</style>
